export const TRACKER_INTERVAL_DEFAULT = 'default'
export const TRACKER_INTERVAL_PERFORMANCE = 'performance'
export const TRACKER_INTERVAL_IDLE = 'idle'

export const TRACKER_INTERVALS = [
  TRACKER_INTERVAL_DEFAULT,
  TRACKER_INTERVAL_PERFORMANCE,
  TRACKER_INTERVAL_IDLE,
]

export const TRACKER_INTERVAL_LABELS = {
  [TRACKER_INTERVAL_PERFORMANCE]: 'performance',
  [TRACKER_INTERVAL_DEFAULT]: 'défaut',
  [TRACKER_INTERVAL_IDLE]: 'repos',
}

export const TRACKER_INTERVAL_COLORS = {
  [TRACKER_INTERVAL_PERFORMANCE]: 'red',
  [TRACKER_INTERVAL_DEFAULT]: 'blue',
  [TRACKER_INTERVAL_IDLE]: 'gray',
}
